import { z } from "zod";

// EcommerceItem
export const EcommerceItemSchema = z.object({
  item_id: z.string(),
  product_id: z.string().optional(),
  item_name: z.string(),
  affiliation: z.string().optional(),
  coupon: z.string().optional(),
  discount: z.number().optional(),
  index: z.number().optional(),
  item_brand: z.string().optional(),
  item_category: z
    .enum([
      "Produkt",
      "Abonnement",
      "Medlemskap",
      "Produktpakke",
      "Digital tjeneste",
    ])
    .optional(),
  item_category2: z.string().optional(),
  item_category3: z.string().optional(),
  item_category4: z.string().optional(),
  item_category5: z.string().optional(),
  item_variant: z.string().optional(),
  item_list_id: z.string().optional(),
  item_list_name: z.string().optional(),
  creative_name: z.string().optional(),
  creative_slot: z.string().optional(),
  promotion_id: z.string().optional(),
  promotion_name: z.string().optional(),
  image_url: z.string().optional(),
  price: z.number().optional(),
  quantity: z.number().optional(),
});

export type EcommerceItem = z.infer<typeof EcommerceItemSchema>;
